
import { ISuKienSelectRequest } from "../../../model/request/tkb/ISuKienSelectRequest";
import { IXepTKBLopTCRespone } from "../../../model/respone/lop-tin-chi/IXepTKBLopTCRespone";
import { IXepTKbLopTinChiFilterLop } from "../../reducer-model/tkb/IXepTKBLopTCReducer";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eXepTKBLopTCActionsObj = {

  CHANGE_FILTER: {} as ISuKienSelectRequest,
  CHANGE_LOPTINCHI_FILTER: {} as IXepTKbLopTinChiFilterLop,

  LOAD_ALL_START: {} as ISuKienSelectRequest,
  LOAD_ALL_SUCCESS: {} as IXepTKBLopTCRespone,
  LOAD_ALL_ERRR: "",

};
export const eXepTKBLopTCActionIds = generateActionTypeIds(
  eXepTKBLopTCActionsObj,
  "XEP_TKB_LOP_TC"
);
export type IXepTKBLopTCActionTypes = IGenericActionType<
  typeof eXepTKBLopTCActionsObj,
  "XEP_TKB_LOP_TC"
>;
